/**
 * Определение языка по стране посетителя (геолокация по IP).
 * RU, BY, KZ, KG, UZ, TJ, AM, AZ, MD → ru; JP → ja; остальные → en.
 */

const RUSSIAN_COUNTRIES = ['RU', 'BY', 'KZ', 'KG', 'UZ', 'TJ', 'AM', 'AZ', 'MD']

const COUNTRY_TO_LANG = Object.fromEntries([
  ...RUSSIAN_COUNTRIES.map((code) => [code, 'ru']),
  ['JP', 'ja'],
])

const VALID_LANGUAGES = ['en', 'ru', 'ja']
const LANG_CHOICE_KEY = 'isuma-lang-choice'
const GEO_COUNTRY_CACHE_KEY = 'isuma-geo-country'

export function getLanguageFromCountry(countryCode) {
  if (!countryCode) return 'en'
  return COUNTRY_TO_LANG[countryCode.toUpperCase()] || 'en'
}

export function getSavedLanguageChoice() {
  const saved = localStorage.getItem(LANG_CHOICE_KEY)
  return VALID_LANGUAGES.includes(saved) ? saved : null
}

export function saveLanguageChoice(lang) {
  if (VALID_LANGUAGES.includes(lang)) {
    localStorage.setItem(LANG_CHOICE_KEY, lang)
  }
}

function cacheCountryCode(country) {
  sessionStorage.setItem(GEO_COUNTRY_CACHE_KEY, country)
  return country
}

async function fetchFromOwnGeoApi(signal) {
  const response = await fetch('/geo/country.php', { signal })
  if (!response.ok) return null

  const data = await response.json()
  if (data.success && data.country_code?.length === 2) {
    return data.country_code.toUpperCase()
  }

  return null
}

async function fetchCountryCode() {
  const cached = sessionStorage.getItem(GEO_COUNTRY_CACHE_KEY)
  if (cached && cached.length === 2) return cached

  const controller = new AbortController()
  const timeoutId = setTimeout(() => controller.abort(), 4000)
  const { signal } = controller

  try {
    const country = await fetchFromOwnGeoApi(signal)
    if (country) {
      return cacheCountryCode(country)
    }
  } catch {
    // Геолокация недоступна — используем английский по умолчанию
  } finally {
    clearTimeout(timeoutId)
  }

  return null
}

export async function detectLanguageFromGeo() {
  const country = await fetchCountryCode()
  return getLanguageFromCountry(country)
}

export async function resolvePreferredLanguage() {
  const saved = getSavedLanguageChoice()
  if (saved) return saved
  return detectLanguageFromGeo()
}
